import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { UserComponent } from 'app/layout/common/user/user.component';
import { AccountSettingsModalComponent } from './modal/settings/account-settings-modal.component';
import { BillingModalComponent } from './modal/billing/billing-modal.component';
import { HelpChatComponent } from './modal/help-chat/help-chat.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        UserComponent
    ],
    imports     : [
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatDialogModule,
        SharedModule,
        AccountSettingsModalComponent,
        BillingModalComponent,
        HelpChatComponent
    ],
    exports     : [
        UserComponent
    ]
})
export class UserModule
{
}
